import React, { useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { specteraAddPowerListsLoad, specteraAddPowerRangeListsLoad, specteraAxisListsLoad, specteraBasicListsLoad, specteraBifocalListsLoad, specteraContactLensIdLoad, specteraCylinderListsLoad, specteraDiameterListsLoad, specteraLensesConfigurationsLoad, specteraSphereListsLoad } from '../../../../../../../../../redux/actions/addOns/rpa/vision_insurance/spectera/specteraAction'
import { Field, FormSection, formValueSelector } from 'redux-form'
import { AutoCompleteSelect, Input, InputWithIcon } from '../../../../../../../../../itrust_common/components/form'

const toSelectOptions = (list, key) => {
  const values = Array.isArray(list)
    ? list
    : (list?.[key] || Object.values(list || {}).find(Array.isArray) || [])
  return values.map(value => (typeof value === 'object' ? value : { label: String(value) }))
}

function SpecteraContactBenefit(props) {
  const { visionInsuranceClaimForm, specteraVisionInsuranceOS, specteraVisionInsuranceOD, styleListOS, styleListOD, portalType, location_id } = props
  const dispatch = useDispatch()
  const [fromActiveData, setFromActiveData] = useState({})
  const [contactLensListOS, setContactLensListOS] = useState([])
  const [contactLensListOD, setContactLensListOD] = useState([])
  const [loading, setLoading] = useState(false)

  const baseCurveOS = toSelectOptions(specteraVisionInsuranceOS.basic_lists, 'BASE_CURVE')
  const baseCurveOD = toSelectOptions(specteraVisionInsuranceOD.basic_lists, 'BASE_CURVE')
  const diameterOS = toSelectOptions(specteraVisionInsuranceOS.diameter_lists, 'DIAMETER')
  const diameterOD = toSelectOptions(specteraVisionInsuranceOD.diameter_lists, 'DIAMETER')
  const sphereOS = toSelectOptions(specteraVisionInsuranceOS.sphere_lists, 'SPHERE')
  const sphereOD = toSelectOptions(specteraVisionInsuranceOD.sphere_lists, 'SPHERE')
  const cylinderOS = toSelectOptions(specteraVisionInsuranceOS.cylinder_lists, 'CYLINDER')
  const cylinderOD = toSelectOptions(specteraVisionInsuranceOD.cylinder_lists, 'CYLINDER')
  const axisOS = toSelectOptions(specteraVisionInsuranceOS.axis_lists, 'AXIS')
  const axisOD = toSelectOptions(specteraVisionInsuranceOD.axis_lists, 'AXIS')

  const handleLoadInfo = (data, lens_type, nextLoad) => {
    data = {
      ...fromActiveData,
      lens_type: lens_type,
      style: lens_type === 'os' ? styleListOS : styleListOD,
      ...data
    }
    setFromActiveData(data)
    setLoading(true)

    let promise
    switch (nextLoad) {
      case 'basic_lists':
        promise = dispatch(specteraBasicListsLoad(visionInsuranceClaimForm.id, data))
        break
      case 'diameter_lists':
        promise = dispatch(specteraDiameterListsLoad(visionInsuranceClaimForm.id, { ...data, location_id }))
        break
      case 'sphere_lists':
        promise = dispatch(specteraSphereListsLoad(visionInsuranceClaimForm.id, { ...data, location_id }))
        break
      case 'cylinder_lists':
        promise = dispatch(specteraCylinderListsLoad(visionInsuranceClaimForm.id, { ...data, location_id }))
        break
      case 'axis_lists':
        promise = dispatch(specteraAxisListsLoad(visionInsuranceClaimForm.id, { ...data, location_id }))
        break
      case 'bifocal_lists':
        promise = dispatch(specteraBifocalListsLoad(visionInsuranceClaimForm.id, { ...data, location_id }))
        break
      case 'lenses_configurations':
        promise = dispatch(specteraLensesConfigurationsLoad(visionInsuranceClaimForm.id, { ...data, location_id }))
        break
      case 'add_power_lists':
        promise = dispatch(specteraAddPowerListsLoad(visionInsuranceClaimForm.id, data))
        break
      case 'add_power_range_lists':
        promise = dispatch(specteraAddPowerRangeListsLoad(visionInsuranceClaimForm.id, data))
        break
      case 'contact_lens_id':
        promise = dispatch(specteraContactLensIdLoad(visionInsuranceClaimForm.id, { ...data, location_id }))
        break
      default:
        break
    }
    Promise.resolve(promise).finally(() => setLoading(false))
  }

  const loader = loading && (
    <div className="form-group col-3 d-flex align-items-end pb-5">
      <div className="spinner-border spinner-border-sm text-primary" role="status" />
      <span className="ml-2 text-muted">Loading...</span>
    </div>
  )

  return (
    <FormSection name="contact">
      <h5 className='mb-5'>Contacts Benefit</h5>
      {(specteraVisionInsuranceOS.style_list.length > 0 && portalType === 'lab') && <div>
        <div className='row'>
          <Field
            name="left_style"
            valueField="STYLE"
            textField="STYLE"
            label="Style (OS)"
            data={specteraVisionInsuranceOS.style_list || []}
            key={`left_style-${specteraVisionInsuranceOS.style_list?.length}`}
            component={AutoCompleteSelect}
            wrapperClasses={`form-group col-3`}
            onChangeHook={(data) => setContactLensListOS(data.ColorList || [])}
          />
          {contactLensListOS.length > 0 && (
            <Field
              name="left_color"
              valueField="CONTACT_LENS_COLOR"
              textField="CONTACT_LENS_COLOR"
              label="Color (OS)"
              data={contactLensListOS || []}
              key={`left_color-${contactLensListOS?.length}`}
              onChangeHook={(data) => handleLoadInfo({ color: data?.CONTACT_LENS_COLOR }, 'os', 'basic_lists')}
              component={AutoCompleteSelect}
              wrapperClasses={`form-group col-3`}
            />
          )}
          {baseCurveOS.length > 0 && (
            <Field
              name="left_base_curve"
              valueField="label"
              textField="label"
              label="Base Curve (OS)"
              data={baseCurveOS}
              key={`left_base_curve-${baseCurveOS.length}`}
              onChangeHook={(data) => handleLoadInfo({ base_curve: data?.label }, 'os', 'diameter_lists')}
              component={AutoCompleteSelect}
              wrapperClasses={`form-group col-3`}
            />
          )}
          {diameterOS.length > 0 && (
            <Field
              name="left_diameter"
              valueField="label"
              textField="label"
              label="Diameter (OS)"
              data={diameterOS}
              key={`left_diameter-${diameterOS.length}`}
              onChangeHook={(data) => handleLoadInfo({ diameter: data?.label }, 'os', 'sphere_lists')}
              component={AutoCompleteSelect}
              wrapperClasses={`form-group col-3`}
            />
          )}
          {sphereOS.length > 0 && (
            <Field
              name="left_sphere"
              valueField="label"
              textField="label"
              label="Sphere (OS)"
              data={sphereOS}
              key={`left_sphere-${sphereOS.length}`}
              onChangeHook={(data) => handleLoadInfo({ sphere: data?.label }, 'os', 'cylinder_lists')}
              component={AutoCompleteSelect}
              wrapperClasses={`form-group col-3`}
            />
          )}
          {cylinderOS.length > 0 && (
            <Field
              name="left_cyclinder"
              valueField="label"
              textField="label"
              label="Cylinder (OS)"
              data={cylinderOS}
              key={`left_cyclinder-${cylinderOS.length}`}
              onChangeHook={(data) => handleLoadInfo({ cylinder: data?.label }, 'os', 'axis_lists')}
              component={AutoCompleteSelect}
              wrapperClasses={`form-group col-3`}
            />
          )}
          {axisOS.length > 0 && (
            <Field
              name="left_axis"
              valueField="label"
              textField="label"
              label="Axis (OS)"
              data={axisOS}
              key={`left_axis-${axisOS.length}`}
              component={AutoCompleteSelect}
              wrapperClasses={`form-group col-3`}
            />
          )}
          {loader}
        </div>
        <div className='row'>
          <Field
            name="left_qtyl_boxes"
            label="Qty/Boxes (OS)"
            component={Input}
            className="form-control"
            wrapperClasses={`form-group col-3`}
          />
          <Field name={`left_billed_amount`} component={InputWithIcon} label="Billed Amount per unit (OS)" title="$" className="form-control" wrapperClasses="form-group col-3" />
          {/* <Field name={`left_total_billed_amount`} component={InputWithIcon} label="Total Billed Amount (OS)" title="$" className="form-control" wrapperClasses="form-group col-3" /> */}
        </div>
      </div>}

      {(specteraVisionInsuranceOS.style_list.length > 0 && portalType === 'nonlab') && <div>
        <div className='row'>
          <Field
            name="left_style"
            valueField="STYLE"
            textField="STYLE"
            label="Style (OS)"
            data={specteraVisionInsuranceOS.style_list || []}
            key={`left_style_nonlab-${specteraVisionInsuranceOS.style_list?.length}`}
            component={AutoCompleteSelect}
            wrapperClasses={`form-group col-3`}
            onChangeHook={(data) => setContactLensListOS(data.ColorList || [])}
          />
          {contactLensListOS.length > 0 && (
            <Field
              name="left_color"
              valueField="CONTACT_LENS_COLOR"
              textField="CONTACT_LENS_COLOR"
              label="Color (OS)"
              data={contactLensListOS || []}
              key={`left_color_nonlab-${contactLensListOS?.length}`}
              onChangeHook={(data) => handleLoadInfo({ color: data?.CONTACT_LENS_COLOR }, 'os', 'basic_lists')}
              component={AutoCompleteSelect}
              wrapperClasses={`form-group col-3`}
            />
          )}
          {baseCurveOS.length > 0 && (
            <Field
              name="left_color"
              valueField="BASE_CURVE"
              textField="BASE_CURVE"
              label="Color (OS)"
              data={baseCurveOS || []}
              key={`left_color_nonlab-${baseCurveOS?.length}`}
              onChangeHook={(data) =>
                handleLoadInfo(
                  { color: data?.BASE_CURVE },
                  'os',
                  'basic_lists'
                )
              }
              component={Input}
              wrapperClasses="form-group col-3"
            />
          )}
          {loader}
        </div>
        <div className='row'>
          <Field
            name="left_qtyl_boxes"
            label="Qty/Boxes (OS)"
            component={Input}
            className="form-control"
            wrapperClasses={`form-group col-3`}
          />
          <Field name={`left_billed_amount`} component={InputWithIcon} label="Billed Charges (OS)" title="$" className="form-control" wrapperClasses="form-group col-3" />
          {/* <Field name={`left_total_billed_amount`} component={InputWithIcon} label="Total Billed (OS)" title="$" className="form-control" wrapperClasses="form-group col-3" /> */}
        </div>
      </div>}

      <hr />
      {(specteraVisionInsuranceOD.style_list.length > 0 && portalType === 'lab') && <div>
        <div className='row'>
          <Field
            name="right_style"
            valueField="STYLE"
            textField="STYLE"
            label="Style (OD)"
            data={specteraVisionInsuranceOD.style_list || []}
            onChangeHook={(data) => setContactLensListOD(data.ColorList || [])}
            key={`right_style-${specteraVisionInsuranceOD.style_list?.length}`}
            component={AutoCompleteSelect}
            wrapperClasses={`form-group col-3`}
          />
          {contactLensListOD.length > 0 && (
            <Field
              name="right_color"
              valueField="CONTACT_LENS_COLOR"
              textField="CONTACT_LENS_COLOR"
              label="Color (OD)"
              data={contactLensListOD || []}
              onChangeHook={(data) => handleLoadInfo({ color: data?.CONTACT_LENS_COLOR }, 'od', 'basic_lists')}
              key={`right_color-${contactLensListOD?.length}`}
              component={AutoCompleteSelect}
              wrapperClasses={`form-group col-3`}
            />
          )}
          {baseCurveOD.length > 0 && (
            <Field
              name="right_base_curve"
              valueField="label"
              textField="label"
              label="Base Curve (OD)"
              data={baseCurveOD}
              key={`right_base_curve-${baseCurveOD.length}`}
              onChangeHook={(data) => handleLoadInfo({ base_curve: data?.label }, 'od', 'diameter_lists')}
              component={AutoCompleteSelect}
              wrapperClasses={`form-group col-3`}
            />
          )}
          {diameterOD.length > 0 && (
            <Field
              name="right_diameter"
              valueField="label"
              textField="label"
              label="Diameter (OD)"
              data={diameterOD}
              key={`right_diameter-${diameterOD.length}`}
              onChangeHook={(data) => handleLoadInfo({ diameter: data?.label }, 'od', 'sphere_lists')}
              component={AutoCompleteSelect}
              wrapperClasses={`form-group col-3`}
            />
          )}
          {sphereOD.length > 0 && (
            <Field
              name="right_sphere"
              valueField="label"
              textField="label"
              label="Sphere (OD)"
              data={sphereOD}
              key={`right_sphere-${sphereOD.length}`}
              onChangeHook={(data) => handleLoadInfo({ sphere: data?.label }, 'od', 'cylinder_lists')}
              component={AutoCompleteSelect}
              wrapperClasses={`form-group col-3`}
            />
          )}
          {cylinderOD.length > 0 && (
            <Field
              name="right_cyclinder"
              valueField="label"
              textField="label"
              label="Cylinder (OD)"
              data={cylinderOD}
              key={`right_cyclinder-${cylinderOD.length}`}
              onChangeHook={(data) => handleLoadInfo({ cylinder: data?.label }, 'od', 'axis_lists')}
              component={AutoCompleteSelect}
              wrapperClasses={`form-group col-3`}
            />
          )}
          {axisOD.length > 0 && (
            <Field
              name="right_axis"
              valueField="label"
              textField="label"
              label="Axis (OD)"
              data={axisOD}
              key={`right_axis-${axisOD.length}`}
              component={AutoCompleteSelect}
              wrapperClasses={`form-group col-3`}
            />
          )}
          {loader}
        </div>
        <div className='row'>
          <Field
            name="right_qtyl_boxes"
            label="Qty/Boxes (OD)"
            component={Input}
            className="form-control"
            wrapperClasses={`form-group col-3`}
          />
          <Field name={`right_billed_amount`} component={InputWithIcon} label="Billed Amount per unit (OD)" title="$" className="form-control" wrapperClasses="form-group col-3" />
          {/* <Field name={`right_total_billed_amount`} component={InputWithIcon} label="Total Billed Amount (OD)" title="$" className="form-control" wrapperClasses="form-group col-3" /> */}
        </div>
      </div>}

      {(specteraVisionInsuranceOD.style_list.length > 0 && portalType === 'nonlab') && <div>
        <div className='row'>
          <Field
            name="right_style"
            valueField="STYLE"
            textField="STYLE"
            label="Style (OD)"
            data={specteraVisionInsuranceOD.style_list || []}
            key={`right_style_nonlab-${specteraVisionInsuranceOD.style_list?.length}`}
            onChangeHook={(data) => setContactLensListOD(data.ColorList || [])}
            component={AutoCompleteSelect}
            wrapperClasses={`form-group col-3`}
          />
          {contactLensListOD.length > 0 && (
            <Field
              name="right_color"
              valueField="CONTACT_LENS_COLOR"
              textField="CONTACT_LENS_COLOR"
              label="Color (OD)"
              data={contactLensListOD || []}
              key={`right_color_nonlab-${contactLensListOD?.length}`}
              onChangeHook={(data) => handleLoadInfo({ color: data?.CONTACT_LENS_COLOR }, 'od', 'basic_lists')}
              component={AutoCompleteSelect}
              wrapperClasses={`form-group col-3`}
            />
          )}
          {loader}
        </div>
        <div className='row'>
          <Field
            name="right_qtyl_boxes"
            label="Qty/Boxes (OD)"
            component={Input}
            className="form-control"
            wrapperClasses={`form-group col-3`}
          />
          <Field name={`right_billed_amount`} component={InputWithIcon} label="Billed Charges (OD)" title="$" className="form-control" wrapperClasses="form-group col-3" />
          <Field name={`right_total_billed_amount`} component={InputWithIcon} label="Total Billed (OD)" title="$" className="form-control" wrapperClasses="form-group col-3" />
        </div>
      </div>}

    </FormSection>
  )
}

const selector = formValueSelector('SpecteraClaimForm')

const mapStateToProps = (state) => {
  const { specteraVisionInsurance } = state
  return {
    specteraVisionInsuranceOS: specteraVisionInsurance.os,
    specteraVisionInsuranceOD: specteraVisionInsurance.od,
    styleListOS: selector(state, 'contact.left_style'),
    styleListOD: selector(state, 'contact.right_style'),
  }
}

export default connect(mapStateToProps)(SpecteraContactBenefit)
